import Icon from "#components/util/Icon";

export default function DropdownIndicatorCell() {
	return (
		<td style={{ minWidth: "20px", maxWidth: "40px" }}>
			<Icon type="angle-down" />
		</td>
	);
}
